export default (props, { rhythm }) => ({
  wrapper: {
    maxWidth: rhythm(14),
    margin: 'auto'
  },
  image: {
    width: 'auto',
    height: 0,
    paddingBottom: '100%'
  }
})
